import { initSwipers } from "../components/swiper";

function initServicePhotoHover() {
  document.querySelectorAll(".services-swiper").forEach((swiperElement) => {
    function initServiceHover() {
      const swiper = swiperElement.swiper;
      if (!swiper) {
        setTimeout(initServiceHover, 100);
        return;
      }
      const slides = swiperElement.querySelectorAll(".service-slide");
      slides.forEach((slide) => {
        const card = slide.querySelector(".service-photo-card");
        if (!card) return;

        card.addEventListener("mouseenter", () => {
          slides.forEach((otherSlide) => {
            if (otherSlide !== slide) {
              otherSlide.classList.remove("is-expanded");
            }
          });
          slide.classList.add("is-expanded");
          swiper.update();
        });
        card.addEventListener("mouseleave", () => {
          slide.classList.remove("is-expanded");
          swiper.update();
        });
      });
    }
    initServiceHover();
  });
}

function initHighlightsScroll() {
  const list = document.querySelector(".highlight-list");
  const btn = document.querySelector(".highlights-toggle");
  if (!list || !btn) return;

  const updateArrow = () => {
    const atBottom =
      list.scrollTop + list.clientHeight >= list.scrollHeight - 5;
    btn.classList.toggle("is-expanded", atBottom);
  };

  btn.addEventListener("click", () => {
    const item = list.querySelector(".highlight-item");
    const step = item.offsetHeight;
    const atBottom =
      list.scrollTop + list.clientHeight >= list.scrollHeight - 5;

    list.scrollBy({
      top: atBottom ? -list.scrollTop : step,
      behavior: "smooth",
    });
  });

  list.addEventListener("scroll", updateArrow, { passive: true });
}

document.addEventListener("DOMContentLoaded", () => {
  initSwipers();
  initServicePhotoHover();
  initHighlightsScroll();
});
